module.exports = __webpack_public_path__ + "media/images/bg/mosaic/ab2-974fbdd63f8b0028f019185a0cacfc73.jpg";